<template>
  <div class="justify-content-center">
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-sm">
            <thead class="thead-light">
            <tr>
              <th>{{'report.name_report' | trans}}</th>
              <th>{{'report.author' | trans}}</th>
              <th class="text-center">CSV</th>
              <th class="text-center">PDF</th>
              <th>{{'report.date_generation' | trans}}</th>
              <th class="action-cell" v-if="!isMensurationForbidden"></th>
            </tr>
            </thead>
            <tbody class="gray-700">
            <tr v-if="!isLoaded">
              <td colspan="6">
                <loader class="table-loader"></loader>
              </td>
            </tr>
            <tr v-if="isEmptyList && isLoaded">
              <td colspan="6" class="text-center">
                <h5>{{'behavior.no_data' | trans }}</h5>
              </td>
            </tr>
            <tr v-for="item in reports" v-if="isLoaded && !isEmptyList">
              <td>
                <router-link
                    v-if="item.type == 1 && !item.isUserDeleted"
                    :to="{ name: 'client-reports',
                        params: {
                          isEdit: isEdit,
                          id: item.clientId,
                          skillFieldId: item.skillFieldId,
                          skillFieldName: item.skillFieldName,
                          clinicId: item.clinicalCenterId,
                          protocolId: item.protocolId,
                          protocolTitle: item.protocolTitle,
                          startDate: item.startDate,
                          endDate: item.endDate,
                          csvShow: typeof item.csv !== 'undefined',
                          pdfShow: typeof item.pdf !== 'undefined',
                          behaviorGraphType: item.undesirableBehaviorGraphType,
                          behaviorUBId: item.undesirableBehaviorBehaviorId,
                          levelLineShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showLevelLine : false) : false,
                          trendLineShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showTrendLine : false) : false,
                          scatterLineShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showScatterLine : false) : false,
                          graphMoYesPercentShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphMoYesPercent : false) : false,
                          graphTotalPercentShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphTotalPercent : false) : false,
                          graphPromptLevelsShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphPromptLevels : false) : false,
                          graphImprovedSPOUShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphImprovedSPOU : false) : false,
                          graphMoYesShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphMoYes : false) : false,
                          graphProbeFullShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphProbeFull : false) : false,
                          graphMoGoalShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphMoGoal : false) : false,
                          graphMandReactShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphMandReact : false) : false,
                          graphGoalShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphGoal : false) : false,
                          graphCumulativeImproveShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphCumulativeImprove : false) : false,
                          graphImprovePromptShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphImprovePrompt : false) : false,
                          graphImproveShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphImprove : false) : false,
                          graphCumulitiveShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphCumulitive : false) : false,
                          graphAboluteShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showAbsolute : false) : false,
                          graphRelativeShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showRelative : false) : false,
                          graphUndesirableBehaviors: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphUndesirableBehaviors : false) : false,
                          }}">
                  {{item.title}}
                </router-link>
                <router-link
                    v-if="item.type == 2 && !item.isUserDeleted"
                    :to="{ name: 'curator-reports',
                        params: {
                          isEdit: isEdit,
                          id: item.curatorId,
                          startDate: item.startDate,
                          endDate: item.endDate
                          }}">
                  {{item.title}}
                </router-link>
                <router-link
                    v-if="item.type == 3 && !item.isUserDeleted"
                    :to="{ name: 'therapist-reports',
                        params: {
                          isEdit: isEdit,
                          id: item.therapistId,
                          startDate: item.startDate,
                          endDate: item.endDate
                          }}">
                  {{item.title}}
                </router-link>
                <span v-if="item.isUserDeleted">{{item.title}} - <i>{{'report.deleted_user' | trans}}</i></span>
                <p class="description mb-0">
                  {{'report.range_from' | trans }} {{item.startDate.date |
                  toLocaleDate}}<br>
                  {{'report.range_end' | trans }} {{item.endDate.date |
                  toLocaleDate}}
                  <span v-if="item.skillFieldName"><br>{{'protocol.area' | trans}}: {{item.skillFieldName}}</span>
                </p>
              </td>
              <td>{{item.owner.fullName}}</td>
              <td class="text-center">
                <a v-if="typeof item.csv !== 'undefined' && item.csv.status == 1 && item.clientId"
                   href="#"
                   class="text-center name-link"
                   @click="downloadCsv(item.csv)">
                  <img src="../../../assets/images/download.png" alt="">
                </a>
                <span
                    v-if="typeof item.csv !== 'undefined' && item.csv.status != 1 && item.clientId">{{ 'report.statusCSV.' + item.csv.status | trans }}</span>
                <a v-if="typeof item.csv == 'undefined' && !item.isUserDeleted && item.clientId"
                   href="#"
                   class="text-center name-link"
                   @click="generateCsv(item)">
                  {{'report.generate' | trans}}
                </a>
              </td>
              <td class="text-center">
                <a v-if="typeof item.pdf !== 'undefined' && item.pdf.status == 2 && item.clientId"
                   href="#"
                   class="text-center name-link"
                   @click="downloadPdf(item)">
                  <img src="../../../assets/images/download.png" alt="">
                </a>
                <span
                    v-if="typeof item.pdf !== 'undefined' && item.pdf.status != 2 && item.clientId">{{ 'report.status.' + item.pdf.status | trans }}</span>
                <a v-if="typeof item.pdf == 'undefined' && !item.isUserDeleted && item.clientId"
                   href="#"
                   class="text-center name-link"
                   @click="generatePdf(item)">
                  {{'report.generate' | trans}}
                </a>
              </td>
              <td>{{toLocaleDateTimeTimezone(item.createdAt.date)}}</td>
              <td class="text-right" v-if="!isMensurationForbidden"><a href="#"
                                                                       class="delete-icon"
                                                                       @click.prevent="showDeletePopup(item.id)">
                <mdc-icon icon="delete"></mdc-icon>
              </a></td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
      <div class="col-12">
        <nav class="nav justify-content-center justify-content-md-start"
             v-if="paginate.lastPage > 1">
          <paginate :page-count="paginate.lastPage"
                    :initial-page="initialPage"
                    :page-range="paginate.pageRange"
                    :margin-pages="paginate.marginPages"
                    :force-page="paginate.forcePage"
                    :click-handler="onPaginationClick"
                    :container-class="'pagination pagination-sm'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'">
            <span slot="prevContent" class="page-link">&laquo;</span>
            <span slot="nextContent" class="page-link">&raquo;</span>
          </paginate>
        </nav>
      </div>
    </div>
    <mdc-dialog v-model="isModalVisible"
                :title="'user.confirm_delete' | trans"
                :accept="'user.delete' | trans"
                :cancel="'user.cancel' | trans"
                @accept="deleteReport()"
                @cancel="onModalClose">

    </mdc-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import {pagination} from '../../../common/mixins/pagination';
  import Auth from '../../../common/auth/Manager';
  import Loader from '../../loader/components/Loader';
  import moment from 'moment';
  import {mapGetters} from 'vuex';
  import Constants from '../../undesirableBehavior/Constants';
  import isEmpty from 'lodash/isEmpty';

  export default {
    name: 'ArchiveList',
    data() {
      return {
        apiUrl: '/statistics/reports',
        reports: {},
        clientId: Auth.getUserInfo().id,
        paginateData: null,
        isModalVisible: false,
        reportId: null,
        isEdit: true,
        isLoaded: false,
        initialPage: null
      };
    },
    mixins: [pagination],
    components: {
      Loader,
    },
    created() {
      if(localStorage.currentPage){
        this.onPaginationClick(localStorage.getItem("currentPage"));
        this.initialPage = +localStorage.getItem("currentPage") - 1;
      } else{
        this.getReports();
        this.initialPage = 1;
      }
    },
    beforeDestroy(){
      localStorage.removeItem('currentPage');
    },
    methods: {
      async onPaginationClick(pageNum) {
        localStorage.setItem('currentPage', pageNum);
        this.onPaginationBtnClick(pageNum);
        await this.getReports();
      },
      getReports: async function() {
        let response;
        this.isLoaded = false;
        try {
          response = await axios.get(
              `${this.apiUrl}/${this.paginate.perPage}/${this.paginate.page}`);
          this.reports = response.data.data.items;
          this.paginateData = response.data.data;
          this.isLoaded = true;

        } catch (error) {
          console.dir(error);
        }
      },
      showDeletePopup(id) {
        this.reportId = id;
        this.isModalVisible = true;
      },

      onModalClose() {
        this.isModalVisible = false;
      },

      toLocaleDateTimeTimezone(date) {
        let dateTime = moment(date, 'YYYY-MM-DD HH:mm').toDate();
        //let dateTime = new Date(date);
        let dateWithTimezone = dateTime.getTime() +
            (Math.abs(dateTime.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE * 1000);

        return moment(dateWithTimezone).format('DD.MM.YYYY HH:mm');
      },

      deleteReport: async function() {
        try {
          this.isLoaded = false;
          let isDeleted = await axios.delete(this.apiUrl + '/' + this.reportId);
          if (isDeleted) {
            this.getReports(
                `${this.apiUrl}/${this.paginate.perPage}/${this.paginate.page}`);
            this.isLoaded = true;
          }
        } catch (error) {
          console.dir(error);
        }
      },

      generateCsv(csv) {
        this.isLoaded = false;
        let id = csv.id;
        axios({
          method: 'post',
          url: 'statistics/reports/clients/' + id + '/csv',
        }).then(response => {
          this.getReports();
        }).catch(() => console.log('error occured'));
      },

      downloadCsv(csv) {
        let file = csv.directory;
        axios({
          method: 'get',
          url: 'statistics/reports/clients/csv/' + file,
          responseType: 'arraybuffer',
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', csv.alias + '.zip');
          document.body.appendChild(link);
          link.click();
        }).catch(() => console.log('error occured'));
      },

      generatePdf(item) {
        this.isLoaded = false;
        let id = item.id;
        axios({
          method: 'post',
          url: 'statistics/reports/clients/' + id + '/pdf',
        }).then(response => {
          this.getReports();
        }).catch(() => console.log('error occured'));
      },

      downloadPdf(item) {
        let id = item.id;
        axios({
          method: 'get',
          url: 'statistics/reports/clients/pdf/' + id,
          responseType: 'arraybuffer',
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', item.pdf.alias + '.pdf');
          document.body.appendChild(link);
          link.click();
        }).catch(() => console.log('error occured'));
      },
    },
    computed: {
      ...mapGetters('auth', [
        'user',
        'isMensurationForbidden',
      ]),
      isEmptyList: function() {
        return isEmpty(this.reports);
      },
    },
    watch: {
      paginateData() {
        this.setPaginate(this.paginateData);
      },
    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/reports/components/ArchiveList.vue